module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAN5JREFUOE+tUkEOgkAMbPEDy4uEJ2m8A3eDTxJfBB/QmrbLLss2QKK9kJR2djozCD8WZvu3sYIPVKFPeAakFxQwSO9e6tdXBLiOLQA2u4QIBgHsy5ZnFeDocoJOHYMgCGV8pv9ggBN1gS7PvLEBXJzGC71DG6Cgen2r+VBBtZ5wmSKDpWBrQZhFUE91yF3Y0oMFfLjadiETU0US6lxBJ9/ftNF4KXUqgugJlhO9S89jnRIXZhtnEdcWcZ+ZaFpiMmNEfQ7k9ol2E2gNSA7+AjAn7SgNzook0crBURA/9wVDomm0j9sdXgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pho.png
// module id = Ld7F
// module chunks = 21